import React from 'react';
import { GrCircleInformation } from 'react-icons/gr';
import { components } from 'react-select';

import { PortableText } from '../portableText';
import * as styles from './group-heading.module.css';

const groupStyles = {
	paddingTop: '15px',
	paddingLeft: '15px',
};

const descriptionStyle = {
	'&p': {
		fontSize: '10px',
	},
};

export function GroupHeading(props) {
	return (
		<div className='group-heading'>
			<span
				className='separator x f'
				style={{ borderBottom: '1px solid #dedcd6' }}
			></span>
			<div style={groupStyles}>
				<div className='f jcs'>
					<components.GroupHeading {...props} />
					{props.data.tooltip && (
						<div className={styles.tooltipContainer}>
							<GrCircleInformation />
							<div className={styles.tooltip}>
								{props.data.tooltip}
							</div>
						</div>
					)}
				</div>

				{props.data.description && (
					<div className='group-description' style={descriptionStyle}>
						<PortableText blocks={props.data.description} />
					</div>
				)}
			</div>
		</div>
	);
}
